$(function () {

    /**
     * https://github.com/ninton/jquery.jpostal.js/
     */
    require('jquery-jpostal-ja');

    $('#zip1').jpostal({
        postcode: [
            '#zip1',
            '#zip2'
        ],
        address: {
            '#addr1': '%3%4%5',
            '#addr2': '%6%7',
        }
    });

    $('#invoice_zip1').jpostal({
        postcode: [
            '#invoice_zip1',
            '#invoice_zip2'
        ],
        address: {
            '#invoice_addr1': '%3%4%5',
            '#invoice_addr2': '%6%7',
        }
    });

});
